import axios from "axios";
import { App } from 'antd';
import { useEffect, useState } from "react";
import AxiosErrorModel, { Data } from "../model/axiosErrorModel";
import { useGlobalContext } from "../model/globalModel";
import localStorageManagement from "./services/localStorageServices";

const useAxios = () => {
    const app = App.useApp();
    const globalContext = useGlobalContext();
    const [error, setError] = useState<AxiosErrorModel | null>(null);
    let port: any;
    let baseUrl: any;
    if (document.location.port === "3000") {
        baseUrl = process.env.REACT_APP_PUBLIC_URL;
    }
    else {
        if (document.location.port !== "80" && document.location.port !== "445") {
            port = ":" + document.location.port.toString();
        }
        baseUrl = document.location.protocol + "//" + document.location.hostname + port + "/api";
    }
    useEffect(() => {
        if (error === null) return;
        if (error.response?.status === 401) {
            localStorageManagement.removeUser();
            app.message.error(`Phiên đăng nhập đã hết hạn`);
        }
        if (error.request?.responseType === "arraybuffer") {
            let errorObject = JSON.parse(new TextDecoder().decode(error?.response?.data as (BufferSource | undefined)));
            app.message.error(`${errorObject.message}`);
            return;
        }
        app.message.error(`${(error?.response?.data as (Data | undefined))?.message}`);
    }, [JSON.stringify(error)])
    const _axios = axios.create({
        baseURL: baseUrl,
        xsrfHeaderName: 'RequestVerificationToken',
    });
    _axios.interceptors.request.use((config) => {
        globalContext.setLoading(true);
        return config;
    })
    _axios.interceptors.response.use(
        (response) => {
            globalContext.setLoading(false);
            return response;
        }, (error) => {
            globalContext.setLoading(false);
            setError(error);
        });
    return _axios;
}
export default useAxios;